@for (toast of toastService.toasts(); track toast) {
  <ngb-toast
    [header]="toast.header ?? ''"
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)"
  >
    @if (toast.template) {
      <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
    } @else {
      {{ toast.body }}
    }
  </ngb-toast>
}
